module.exports = "/assets/data/067d54133d07a16dc7adcea08bde33b6-CT2.data.json";